import React from 'react';
import { sendDocuSignEnvelope } from '../data/sendDocuSignEnvelope';
import { DocuSignEnvelope } from '../types/Signatures/DocuSignEnvelope';
import { DocuSignSigBoxProps } from '../types/Signatures/DocuSignSigBoxProps';
import { Button } from './buttons/Button';
import { useUpdateChartSection } from '../hooks/useUpdateChartSection';
import * as Sentry from '@sentry/browser';

export const DocuSignSigBox = (props: DocuSignSigBoxProps) => {
  const { mutate } = useUpdateChartSection();
  const [witnessEmail, setWitnessEmail] = React.useState('');
  // const [witnessName, setWitnessName] = React.useState('');
  const [sendingEnvelope, setSendingEnvelope] = React.useState(false);

  const handleFirestoreUpdate = () => {
    mutate(
      {
        patientId: props.patientId,
        docData: {
          WITNESS_SIGNATURE: {
            signature1DataURI:
              props.witnessNumber === 1
                ? ''
                : (props.data.WITNESS_SIGNATURE && props.data.WITNESS_SIGNATURE?.signature1DataURI) || '',
            witnessName: props.witnessNumber === 1 ? props.witnessName : props.data.WITNESS_SIGNATURE.witnessName || '',
            witnessEmail: props.witnessNumber === 1 ? witnessEmail : props.data.WITNESS_SIGNATURE.witnessEmail || '',
            signature2DataURI: props.witnessNumber === 2 ? '' : props.data.WITNESS_SIGNATURE.signature2DataURI || '',
            witness2Name:
              props.witnessNumber === 2 ? props.witnessName : props.data.WITNESS_SIGNATURE.witness2Name || '',
            witness2Email: props.witnessNumber === 2 ? witnessEmail : props.data.WITNESS_SIGNATURE.witness2Email || '',
          },
        },
      },
      {
        onSuccess: () => {
          // alert("Successfully updated document");
        },
        onError: (error) => {
          Sentry.captureException(error);
          alert(`Error updating document: ${error.message}`); // TELL THE USER
          console.error(error); // GET THE STACKTRACE
        },
      },
    );
  };

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    setSendingEnvelope(true);
    const payload = {
      patientUid: props.patientId,
      signatureType: props.witnessNumber === 1 ? 'witness' : `witness${props.witnessNumber}`,
      ccName: props.patientName,
      ccEmail: props.patientEmail,
      signerName: props.witnessName,
      signerEmail: witnessEmail,
      teleprompterScript: props.script,
    } as DocuSignEnvelope;

    const res = await sendDocuSignEnvelope(payload);
    if (res === 'SUCCESS') {
      try {
        handleFirestoreUpdate();
        setSendingEnvelope(false);
      } catch (error) {
        Sentry.captureException(error);
        console.error('Error updating Firestore with signature information', error);
        setSendingEnvelope(false);
        throw new Error('Error updating Firestore with signature information');
      }
      alert('Witness request email sent successfully');
    } else {
      // ALERTING HANDLED IN FUNCTION CALL
      // alert('Error sending DocuSign envelope');
      setSendingEnvelope(false);
    }
  };
  return (
    <div>
      {sendingEnvelope ? (
        <div role="status">
          <svg
            aria-hidden="true"
            className="inline h-10 w-10 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="">{`Sending Email to ${witnessEmail}`}</span>
        </div>
      ) : (
        <form>
          <label className="text-xl font-bold" htmlFor="witnessEmail">
            {`Witness ${props.witnessNumber} Email Address:`}
          </label>
          <input
            id="witnessEmail"
            type="email"
            placeholder="Witness Email Address"
            onChange={(e) => setWitnessEmail(e.target.value)}
            // className="mx-2 p-1 outline"
            className="block rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-lg text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
          />
          <Button
            id="submit-DocuSign-email"
            type="submit"
            onClick={(e: React.MouseEvent) => handleSubmit(e)}
            textContent={`Submit Witness ${props.witnessNumber} Info`}
            disabled={!props.witnessName || witnessEmail.length === 0}
          />
        </form>
      )}
    </div>
  );
};
